module.exports = __webpack_public_path__ + "static/media/ebook-1.4bb17a53.png";